import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { Product } from "../types";

export const updateProductApi = (userId: string, product: Product) =>
	webApiWithResponse<string>({
		method: "PUT",
		url: "listing/updprod",
		params: {
			userId
		},
		data: product
	});

export default updateProductApi;
